module.exports = __webpack_public_path__ + "map1.5b97aca2.png";